// js
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';


function SourcesHeaderNav({ area, areas, dsa, activeAreaIds, baseNavRoute }) {
  const previousAreaId = area && activeAreaIds && activeAreaIds[activeAreaIds.indexOf(area.id) - 1];
  const previousArea = areas.find(a => a.id === previousAreaId);
  const nextAreaId = area && activeAreaIds && activeAreaIds[activeAreaIds.indexOf(area.id) + 1];
  const nextArea = areas.find(a => a.id === nextAreaId);

  return (

    <div className='sources-header-nav'>
      {!!area &&
        <div className='next-prev-links'>
          {previousArea &&
            <Link
              to={`${baseNavRoute}/sources/${previousArea.id}`}
              className='prev-link'>&#60; Previous: {previousArea.title}
            </Link>
          }
          {dsa && !previousArea &&
            <Link
              to={`${baseNavRoute}/sources`}
              className='prev-link'>&#60; Previous: Overview
              </Link>
          }
          {nextArea &&
            <Link
              to={`${baseNavRoute}/sources/${nextArea.id}`}
              className='next-link'>Next: {nextArea.title} &#62;
              </Link>}
          {dsa && !nextArea &&
            <Link
              to={`${baseNavRoute}/analytics`}
              className='next-link'>Next: Analytics &#62;
              </Link>
          }
        </div>
      }
    </div>
  );
}

SourcesHeaderNav.propTypes = {
  baseNavRoute: PropTypes.string.isRequired,
  area: PropTypes.object,
  areas: PropTypes.array,
  dsa: PropTypes.object,
  activeAreaIds: PropTypes.array
};

export default SourcesHeaderNav;



// WEBPACK FOOTER //
// ./src/components/sources/SourcesHeaderNav.js